module.exports = __webpack_public_path__ + "static/media/clipboard.b1c79e4b.svg";